module.exports = __webpack_public_path__ + "static/media/9.5a2751e2.svg";